import React, {Component} from 'react';
import Api from "../../utils/Api";
import moment from 'moment';
import StaticFunctions from "../../utils/StaticFunctions";
import CSVDownloadButton from "../../utils/CSVDownloadButton";
import PDFDownloadButton from "../../utils/PDFDownloadButton";
import DOMDownloadButton from "../../utils/DOMDownloadButton";
import TimerangeSelector from "../../globalComponents/TimerangeSelector";
import MachineSelector from "../../globalComponents/MachineSelector";
import TimeRange from "../../utils/TimeRange";
import ShiftSelector from "../../globalComponents/ShiftSelector";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import GroupingSelector from "../../globalComponents/GroupingSelector";
import TableContainer from "../../utils/TableContainer";
import ThreadbreaksByMachineBarChart from "../../utils/charts/ThreadbreaksByMachineBarChart";
import CheckBoxField from "../../utils/CheckBoxField";
import domtoimage from 'dom-to-image';

import "../../css/style-chart.css";

class ReportThreadbreaksByMachine extends Component {
/*
    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machines: PropTypes.instanceOf(Machines).isRequired,
    };
*/
    constructor(props) {

        super(props);

        this.api = new Api();

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);
        this.saveSettings = this.props.baseData.saveSettings;
        this.resizeTimer = null;
        this.groupingOpt = [
            {id: 'HN', name: this.translate('head') + ' & ' + this.translate('needle')},
            {id: 'H', name: this.translate('head')},
            {id: 'N', name: this.translate('needle')}
        ];

        this.state = {
            reportStatus: null,
            reportParams: null,
            timeRange: null, // TimeRange
            showSubThreadbreaks: false,
            reverseHeadOrder: false,
            selectedMachine: null,
            selectedShift: null,
            selectedGrouping: 'HN',
            currentCompanyId: props.baseData.companies.currentCompany ? props.baseData.companies.currentCompany.id : null,
            initialParams: null,
            requestedParams: null, // stringified parameters to prevent double-request
            chartAreaWidth: 800,
            legend: [],
            tableData: null,
            chartData: null, // chartdata from server
            errorData: null,
            pdfChartUrls: null
        };

        this.reportKey = 'threadbreaksByMachine';

        this.timerangeChanged = this.timerangeChanged.bind(this);
        this.requestReport = this.requestReport.bind(this);
        this.requestPdfContent = this.requestPdfContent.bind(this);
        this.machineSelected = this.machineSelected.bind(this);
        this.reportResult = this.reportResult.bind(this);
        this.shiftSelected = this.shiftSelected.bind(this);
        this.groupingSelected = this.groupingSelected.bind(this);
        this.toggleCheckBox = this.toggleCheckBox.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
        this.getPdfContent = this.getPdfContent.bind(this);

    }

    componentWillMount() {

        const newState = {};

        // Timerange aus den userprops laden
        const tr = new TimeRange();
        const momentYesterday = moment().add(-1, 'days');

        tr.setRange(momentYesterday.clone().startOf('day'), momentYesterday.clone().endOf('day'));

        if (tr && tr.isValid()) newState.timeRange = tr;

        // Machines aus den userprops laden
        const machine = this.getReportSetting('machine');

        if (machine) {
            const parseMachine = JSON.parse(machine);

            if (parseMachine.value !== 'all') newState.selectedMachine = parseMachine;
        }

        // Shift aus den userprops laden
        const sid = this.getReportSetting('shiftId');

        if (sid) {
            let shift = this.props.baseData.shifts.getShiftById(sid);

            if (shift) newState.selectedShift = shift;
        }

        // Grouping aus den userprops laden
        const grouping = this.getReportSetting('grouping');

        if (grouping) newState.selectedGrouping = grouping;

        // ShowSubThreadbreaks aus den userprops laden
        const showSubThreadbreaks = this.getReportSetting('showSubThreadbreaks', false);

        if (showSubThreadbreaks) newState.showSubThreadbreaks = true;

        // ReverseHeadOrder aus den userprops laden
        const reverseHeadOrder = this.getReportSetting('reverseHeadOrder', false);

        if (reverseHeadOrder) newState.reverseHeadOrder = true;

        if (newState) this.setState(newState);

    }

    componentDidMount() {

        this.updateDimensions();

        window.addEventListener("resize", this.updateDimensions);

    }

    componentWillUnmount() {

        window.removeEventListener("resize", this.updateDimensions);

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.baseData.companies && nextProps.baseData.companies.currentCompany) {
            if (nextProps.baseData.companies.currentCompany.id !== this.state.currentCompanyId) {
                this.setState({
                    chartData: null,
                    selectedMachine: null,
                    currentCompanyId: nextProps.baseData.companies.currentCompany.id
                });
            }
        }

    }

    getReportSetting(key, defaultValue = null) {

        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};
        const reportSettings = (settings.hasOwnProperty('reports') && settings.reports.hasOwnProperty(this.reportKey)) ? settings.reports[this.reportKey] : {};

        return (reportSettings.hasOwnProperty(key)) ? reportSettings[key] : defaultValue;

    }

    updateDimensions() {

        const adjust = () => {
            try {
                this.resizeTimer = 0;
                // try to adjust chart width
                const newWidth = this.chartArea.offsetWidth > 300 ? this.chartArea.offsetWidth : 300;

                if (newWidth !== this.state.chartAreaWidth) {
                    this.setState({chartAreaWidth: newWidth});
                }
            } catch (e) {
            }
        };

        if (this.resizeTimer === null) adjust();

        if (this.resizeTimer > 0) window.clearTimeout(this.resizeTimer);

        this.resizeTimer = window.setTimeout(adjust, 75);

    }

    getRequestParams() {

        const tr = this.state.timeRange;
        const dateFrom = tr ? tr.getFromMoment() : null;
        const dateTill = tr ? tr.getTillMoment() : null;
        const machineId = this.state.selectedMachine ? this.state.selectedMachine.value : null;
        const grouping = this.state.selectedGrouping ? this.state.selectedGrouping : null;

        // Check, if all data is set
        if (!dateFrom || !dateTill || !machineId || !grouping) return null;
        if (!dateFrom.isValid() || !dateTill.isValid()) return null;

        return {
            machineId: machineId,
            companyId: this.props.baseData.companies.currentCompany.id,
            from: dateFrom.unix(),
            till: dateTill.unix(),
            showSubThreadbreaks: this.state.showSubThreadbreaks,
            reverseHeadOrder: this.state.reverseHeadOrder,
            grouping: grouping,
            shift: this.state.selectedShift ? this.state.selectedShift.getRange() : null,
            timezone: this.props.baseData.companies.currentCompany.timezone,
        };

    }

    requestReport() {

        if (this.state.reportStatus === 'requested') return null;

        const params = this.getRequestParams();

        if (params === null) return null;

        const sParams = JSON.stringify(params);

        if (sParams === this.state.requestedParams) return null;

        const {reportParams, ...newReportParams} = {...this.state};

        const error = function(error) {
            if (error) {
                this.setState({
                    reportStatus: 'error',
                    tableData: null,
                    chartData: null,
                    errorData: error,
                });
            }
        }.bind(this);

        this.setState({
            reportStatus: 'requested',
            reportParams: newReportParams,
            requestedParams: sParams,
            tableData: null,
            chartData: null,
            errorData: null,
            pdfChartUrls: null,
        }, () => {
            this.api.request('ReportThreadBreaks', params, this.reportResult, error);
            this.createChartArray();
        });

    }

    requestPdfContent() {

        const domElement = document.getElementById('chartArea');

        if (domElement) {
            window.setTimeout(() => {
                domtoimage.toPng(domElement).then(function (dataUrl) {
                    this.setState({
                        pdfChartUrls: dataUrl
                    });
                }.bind(this))
            }, 1000);
        }

    }

    timerangeChanged(newRange) {

        if (newRange && (newRange instanceof TimeRange) && newRange.isValid()) {
            this.setState({
                timeRange: newRange,
            });

            // Safe Timerange to Userconfig
            if (this.saveSettings) {
                this.saveSettings('reports', {report: this.reportKey, key: 'timeRange', value: newRange.serialize()});
            }
        }

    }

    machineSelected(machine) {

        this.setState({
            selectedMachine: machine
        });

        // Safe Machine to Userconfig
        if (this.saveSettings) {
            this.saveSettings('reports', {report: this.reportKey, key: 'machine', value: ((machine) ? JSON.stringify(machine) : null)});
        }

    }

    shiftSelected(shift) {

        this.setState({
            selectedShift: shift
        });

        // Safe Shift-id to Userconfig
        if (this.saveSettings && shift) {
            this.saveSettings('reports', {report: this.reportKey, key: 'shiftId', value: shift.id});
        }

    }

    groupingSelected(grouping) {

        this.setState({
            selectedGrouping: grouping.id
        });

        // Safe grouping to Userconfig
        if (this.saveSettings && grouping) {
            this.saveSettings('reports', {report: this.reportKey, key: 'grouping', value: grouping.id});
        }

    }

    toggleCheckBox(fieldName, isChecked) {

        const state = {...this.state};

        state[fieldName] = isChecked;

        this.setState(state);

        // Safe option to Userconfig
        if (this.saveSettings && isChecked !== null) {
            this.saveSettings('reports', {report: this.reportKey, key: fieldName, value: isChecked});
        }

    }

    reportResult(result) {

        if (!this.state.reportParams) return null;

        const grouping = this.state.reportParams.selectedGrouping;

        let grid = [];

        if (grouping) {
            switch (grouping) {
                case 'HN':
                    grid = this.getFilledGridForHN(result);
                    break;

                case 'H':
                    grid = this.getFilledGridForH(result);
                    break;

                case 'N':
                    grid = this.getFilledGridForN(result);
                    break;
            }
        }

        this.setState({
            reportStatus: 'ready',
            tableData: result,
            chartData: grid
        }, () => {
            this.requestPdfContent();
        });

    }

    // Aktuelles Chart mit leeren Werten fuellen
    createChartArray() {

        if (!this.state.reportParams) return null;

        const grouping = this.state.reportParams.selectedGrouping;

        if (grouping) {
            let grid = [];
            let legend = [];

            switch (grouping) {
                case 'HN':
                    legend = this.getLegendForHN();
                    grid = this.getEmptyGridForHN();
                    break;

                case 'H':
                    legend = this.getLegendForH();
                    grid = this.getEmptyGridForH();
                    break;

                case 'N':
                    legend = this.getLegendForN();
                    grid = this.getEmptyGridForN();
                    break;
            }

            this.setState({
                legend: legend,
                chartData: grid,
            });
        }

    }

    getHeadsOfSelectedMachine() {

        if (!this.state.reportParams) return null;

        const heads = this.props.machines.getMachineHeadsByMachineId(this.state.reportParams.selectedMachine.value);

        return (heads) ? heads : 1;

    }

    getNeedlesOfSelectedMachine() {

        if (!this.state.reportParams) return null;

        const machine = this.props.machines.getMachineByMachineId(this.state.reportParams.selectedMachine.value);

        return (machine) ? machine.getNeedles() : 1;

    }

    getLegendForHN() {

        if (!this.state.reportParams) return null;

        const needles = this.getNeedlesOfSelectedMachine();
        const init = (this.state.reportParams.showSubThreadbreaks) ? 0 : 1;
        const legend = [];

        for (let i = init; i <= needles; i++) {
            legend[i] = {
                key: 'needle' + i,
                label: (i === 0) ? this.translate('bobbinThread') : this.translate('needle') + ' ' + i,
            };
        }

        return legend;

    }

    getEmptyGridForHN() {

        const heads = this.getHeadsOfSelectedMachine();
        const needles = this.getNeedlesOfSelectedMachine();
        const emptyRow = {};
        const grid = [];

        for (let i = 0; i <= needles; i++) {
            emptyRow['needle' + i] = 0;
        }

        for (let j = 1; j <= heads; j++) {
            let rowTemp = {...emptyRow};

            rowTemp['key'] = 'head' + j;
            rowTemp['label'] = this.translate('head') + ' ' + j;

            grid.push(rowTemp);
        }

        if (this.state.reportParams.reverseHeadOrder) return grid.reverse();

        return grid;

    }

    getFilledGridForHN(result) {

        const grid = this.getEmptyGridForHN();

        for (let i in result) {
            let head = result[i].head;
            let needle = result[i].needle;
            let threadbreaks = result[i].threadbreaks;

            for (let j in grid) {
                let gridTemp = grid[j];

                if (gridTemp.key === 'head' + head) gridTemp['needle' + needle] = threadbreaks;
            }
        }

        return grid;

    }

    getLegendForH() {

        return [
            {
                key: 'tb',
                label: this.translate('threadbreaks'),
            }
        ];

    }

    getEmptyGridForH() {

        const heads = this.getHeadsOfSelectedMachine();
        const grid = [];

        for (let i = 1; i <= heads; i++) {
            grid.push({
                key: 'head' + i,
                label: this.translate('head') + ' ' + i,
                tb: 0,
            });
        }

        if (this.state.reportParams.reverseHeadOrder) return grid.reverse();

        return grid;

    }

    getFilledGridForH(result) {

        const grid = this.getEmptyGridForH();

        for (let i in result) {
            let head = result[i].head;
            let threadbreaks = result[i].threadbreaks;

            for (let j in grid) {
                let gridTemp = grid[j];

                if (gridTemp.key === 'head' + head) gridTemp.tb = threadbreaks;
            }
        }

        return grid;

    }

    getLegendForN() {

        return [
            {
                key: 'tb',
                label: this.translate('threadbreaks'),
            }
        ];

    }

    getEmptyGridForN() {

        if (!this.state.reportParams) return null;

        const needles = this.getNeedlesOfSelectedMachine();
        const init = (this.state.reportParams.showSubThreadbreaks) ? 0 : 1;
        const grid = [];

        for (let i = init; i <= needles; i++) {
            grid.push({
                key: 'needle' + i,
                label: (i === 0) ? this.translate('bobbinThread') : this.translate('needle') + ' ' + i,
                tb: 0
            });
        }

        return grid;

    }

    getFilledGridForN(result) {

        const grid = this.getEmptyGridForN();

        for (let i in result) {
            let needle = result[i].needle;
            let threadbreaks = result[i].threadbreaks;

            for (let j in grid) {
                let gridTemp = grid[j];

                if (gridTemp.key === 'needle' + needle) gridTemp.tb = threadbreaks;
            }
        }

        return grid;

    }

    getErrorBlock() {

        let errorBlock = null;

        if (this.state.errorData || this.state.reportStatus === 'error') {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('errorOccured')}</span>;
        } else if (!this.state.reportParams.timeRange || !this.state.reportParams.timeRange.isValid()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsUnset')}</span>;
        } else if (!this.state.reportParams.timeRange.isNotInFuture()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsInFuture')}</span>;
        } else if (this.state.reportParams.selectedMachine === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('machineIsUnset')}</span>;
        } else if (this.state.reportParams.selectedDesign === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('designIsUnset')}</span>;
        } else if (this.state.tableData === null) {
            errorBlock = <LoadingSplash color={'dark'}/>;
        } else if (this.state.tableData && this.state.tableData.length === 0) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('noDataFound')}</span>;
        }

        return (errorBlock !== null) ? errorBlock : null;

    }

    getChartHeadline(timeRange, otherParams = {}) {

        const params = {
            machine: this.state.reportParams.selectedMachine,
            machineTitle: this.translate('machine'),
            allMachinesTitle: this.translate('allMachines'),
            design: this.state.reportParams.selectedDesign,
            designTitle: this.translate('design'),
            allDesignsTitle: this.translate('allDesigns'),
            timerange: timeRange,
            formatedDate: this.timeFormats.fullDate,
            timerangeTitle: this.translate('timerange'),
            shift: this.state.reportParams.selectedShift,
            shiftTitle: this.translate('shift'),
            groupingOpt: this.groupingOpt,
            groupingId: this.state.reportParams.selectedGrouping,
            groupingTitle: this.translate('grouping')
        };

        return StaticFunctions.createReportHeadlineFromParams({...params, ...otherParams});

    }

    getChartHeader(timeRange) {

        const headline = this.getChartHeadline(timeRange);

        if (headline === null) return null;

        return (
            <nav>
                <h1>{headline}</h1>
            </nav>
        );

    }

    getChartBlock(timeRange, chartData) {

        const chartHeader = this.getChartHeader(timeRange);

        return (
            <div>
                {chartHeader}

                <div className="chartBox">
                    <ThreadbreaksByMachineBarChart
                        data={chartData}
                        legend={this.state.legend}
                        label={this.translate('threadbreaks')}
                        width={1700}
                    />
                </div>
            </div>
        );

    }

    getCsvContent() {

        const csvContent = {
            csvTitle: [],
            csvColumns: [],
            csvData: []
        };

        if (this.state.reportStatus === 'ready') {
            const timeRange = this.state.reportParams.timeRange;

            csvContent.csvTitle.push(this.getChartHeadline(timeRange));
            csvContent.csvColumns.push(this.getTableColumns());
            csvContent.csvData.push(this.getTableRows());
        }

        return csvContent;

    }

    getPdfContent() {

        return {
            charts: (this.state.pdfChartUrls) ? [this.state.pdfChartUrls] : null,
            orientation: 'L',
            tableColumns: this.getTableColumns(),
            tableRows: this.getTableRows()
        };

    }

    getTableColumns() {

        if (!this.state.reportParams) return null;

        const grouping = this.state.reportParams.selectedGrouping;
        const columns = [];

        if (grouping) {
            switch (grouping) {
                case 'HN':
                    columns.push({
                        key: 'head',
                        nameKey: 'head',
                        classes: 'text-right',
                        sortType: 'int',
                    });
                    columns.push({
                        key: 'needle',
                        nameKey: 'needle',
                        classes: 'text-right',
                        sortType: 'int',
                    });
                    break;

                case 'H':
                    columns.push({
                        key: 'head',
                        nameKey: 'head',
                        classes: 'text-right',
                        sortType: 'int',
                    });
                    break;

                case 'N':
                    columns.push({
                        key: 'needle',
                        nameKey: 'needle',
                        classes: 'text-right',
                        sortType: 'int',
                    });
                    break;
            }

            columns.push({
                key: 'threadbreaks',
                nameKey: 'threadbreaks',
                classes: 'text-right',
                sortType: 'int',
            });
        }

        return columns;

    }

    getTableRows() {
        if (!this.state.reportParams) return [];

        const heads = this.getHeadsOfSelectedMachine();
        const needles = this.getNeedlesOfSelectedMachine();
        const grouping = this.state.reportParams.selectedGrouping;
        const tableData = this.state.tableData;
        const init = (this.state.reportParams.showSubThreadbreaks) ? 0 : 1;
        const rows = [];

        let threadbreakCounter = 0;

        if (tableData && grouping) {
            switch (grouping) {
                case 'HN':
                    for (let i = 1; i <= heads; i++) {
                        for (let j = init; j <= needles; j++) {
                            const result = StaticFunctions.filterObjectsInArray(tableData, ['head', 'needle'], [i, j]);
                            const threadbreaks = (result.length === 1) ? result[0].threadbreaks : 0;

                            threadbreakCounter += threadbreaks;

                            rows.push({
                                head: StaticFunctions.formatedNumber(i),
                                needle: StaticFunctions.formatedNumber(j),
                                threadbreaks: StaticFunctions.formatedNumber(threadbreaks)
                            });
                        }
                    }

                    if (rows.length > 0) {
                        rows.push({
                            id: 'sum',
                            head: this.translate('sum'),
                            needle: ' ',
                            threadbreaks: StaticFunctions.formatedNumber(threadbreakCounter)
                        });
                    }
                    break;

                case 'H':
                    for (let i = 1; i <= heads; i++) {
                        const rowData = StaticFunctions.findObjectInArray(tableData, 'head', i);
                        const threadbreaks = (rowData !== null) ? rowData.threadbreaks : 0;

                        threadbreakCounter += threadbreaks;

                        rows.push({
                            head: StaticFunctions.formatedNumber(i),
                            threadbreaks: StaticFunctions.formatedNumber(threadbreaks)
                        });
                    }

                    if (rows.length > 0) {
                        rows.push({
                            id: 'sum',
                            head: this.translate('sum'),
                            threadbreaks: StaticFunctions.formatedNumber(threadbreakCounter)
                        });
                    }
                    break;

                case 'N':
                    for (let i = init; i <= needles; i++) {
                        const rowData = StaticFunctions.findObjectInArray(tableData, 'needle', i);
                        const threadbreaks = (rowData !== null) ? rowData.threadbreaks : 0;

                        threadbreakCounter += threadbreaks;

                        rows.push({
                            needle: StaticFunctions.formatedNumber(i),
                            threadbreaks: StaticFunctions.formatedNumber(threadbreaks)
                        });
                    }

                    if (rows.length > 0) {
                        rows.push({
                            id: 'sum',
                            needle: this.translate('sum'),
                            threadbreaks: StaticFunctions.formatedNumber(threadbreakCounter)
                        });
                    }
                    break;
            }
        }

        return rows;

    }

    generateChart() {

        if (!this.state.reportParams) return null;

        const chartBlock = this.getChartBlock(this.state.reportParams.timeRange, this.state.chartData);

        return chartBlock;

    }

    generateTable() {

        if (!this.state.reportParams) return null;

        const tableColumns = this.getTableColumns();
        const tableRows = this.getTableRows();

        return (
            <TableContainer
                baseData={this.props.baseData}
                columns={tableColumns}
                rows={tableRows}
                maxWidth={750}
            />
        );

    }

    renderRequestButton() {

        const reportParams = this.getRequestParams();
        const sParams = JSON.stringify(reportParams);

        if (this.state.reportStatus === 'requested' || sParams === this.state.requestedParams) {
            return (
                <a className="prewLink disabled-link">{this.translate('requestReport')}</a>
            );
        } else {
            return (
                <a className="prewLink orangeButton" onClick={() => this.requestReport()}>{this.translate('requestReport')}</a>
            );
        }

    }

    renderDownloadButtons() {

        if (this.state.reportStatus !== 'ready' || !this.state.reportParams || this.getErrorBlock() !== null) {
            return (
                <div className="bottomLinks clearfix">
                    <div><button className="disabled-link">{this.translate('csvDownloadLabel') + ' (CSV)'}</button></div>
                    <div><button className="disabled-link">{this.translate('imageDownloadLabel') + ' (PNG)'}</button></div>
                    <div><button className="disabled-link">{this.translate('pdfDownloadLabel') + ' (PDF)'}</button></div>
                </div>
            );
        } else {
            const csvContent = this.getCsvContent();
            const pdfContent = this.getPdfContent();

            return (
                <div className="bottomLinks clearfix">
                    <CSVDownloadButton
                        baseData={this.props.baseData}
                        fileName={this.props.reportName}
                        csvTitle={csvContent.csvTitle}
                        columns={csvContent.csvColumns}
                        data={csvContent.csvData}
                    />

                    <DOMDownloadButton
                        baseData={this.props.baseData}
                        fileName={this.props.reportName}
                        domId={'chartArea'}
                    />

                    <PDFDownloadButton
                        baseData={this.props.baseData}
                        fileName={this.props.reportName}
                        charts={pdfContent.charts}
                        tableColumns={pdfContent.tableColumns}
                        tableRows={pdfContent.tableRows}
                    />
                </div>
            );
        }

    }

    renderChartArea() {

        if (this.state.reportStatus === null) return null;
        if (this.state.reportStatus === 'requested') return <LoadingSplash color={'dark'}/>;

        const errorBlock = this.getErrorBlock();

        if (errorBlock !== null) return errorBlock;

        return this.generateChart();

    }

    renderTableArea() {

        if (this.state.reportStatus === null) return null;
        if (this.state.reportStatus === 'requested') return null;

        const errorBlock = this.getErrorBlock();

        if (errorBlock !== null) return null;

        return this.generateTable();

    }

    render() {

        const timerangeFormat = this.timeFormats.fullDate;
        const chartArea = this.renderChartArea();
        const tableArea = this.renderTableArea();
        const requestButton = this.renderRequestButton();
        const downloadArea = this.renderDownloadButtons();

        return (
            <div>
                <div id="reportSettings" className="clearfix">
                    <div className="clearfix">
                        <div className="col-sm-4">
                            <div className="ma-bo-10">
                                <h4>{this.translate('timerange')}</h4>

                                <div>
                                    <TimerangeSelector
                                        TimeRange={this.state.timeRange}
                                        displayFormat={timerangeFormat}
                                        translate={this.translate}
                                        onTimeRangeChanged={this.timerangeChanged}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('machine')}</h4>

                                <div>
                                    <MachineSelector
                                        machine={this.props.machines}
                                        currentMachine={this.state.selectedMachine}
                                        translate={this.translate}
                                        onMachineSelected={(machine) => this.machineSelected(machine)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('shift')}</h4>

                                <div>
                                    <ShiftSelector
                                        baseData={this.props.baseData}
                                        currentShift={this.state.selectedShift}
                                        translate={this.translate}
                                        onShiftSelected={(shift) => this.shiftSelected(shift)}
                                    />
                                </div>
                            </div>

                            <div className="ma-bo-10">
                                <h4>{this.translate('grouping')}</h4>

                                <div>
                                    <GroupingSelector
                                        translate={this.translate}
                                        currentGrouping={this.state.selectedGrouping}
                                        onGroupingSelected={(grouping) => this.groupingSelected(grouping)}
                                    />
                                </div>
                            </div>

                            <div className="formSettings ma-bo-10">
                                <h4>{this.translate('options')}</h4>

                                <div className="formBox">
                                    <CheckBoxField
                                        name="showSubThreadbreaks"
                                        label={this.translate('showSubThreadbreaks')}
                                        isChecked={this.state.showSubThreadbreaks}
                                        onChange={this.toggleCheckBox}
                                    />

                                    <CheckBoxField
                                        name="reverseHeadOrder"
                                        label={this.translate('reverseHeadOrder')}
                                        isChecked={this.state.reverseHeadOrder}
                                        onChange={this.toggleCheckBox}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('downloadReport')}</h4>

                                {downloadArea}
                            </div>
                        </div>
                    </div>

                    <div className="bottomLinks clearfix">
                        {requestButton}
                    </div>
                </div>

                <div id="reportArea" className="clearfix">
                    <div id="chartArea" className="ma-bo-10">
                        {chartArea}
                    </div>

                    <div id="tableArea" className="ma-bo-10">
                        {tableArea}
                    </div>
                </div>
            </div>
        );

    }

}

export default ReportThreadbreaksByMachine;
